import { Component, HostBinding, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Small copy-to-clipboard icon for a property value. Unless `alwaysVisible` is set, it stays
 * hidden until the pointer is over a `.copyable` ancestor or the button has keyboard focus.
 */
@Component({
  selector: 'copy-value',
  templateUrl: './copy-value.component.html',
  styleUrls: ['./copy-value.component.scss']
})
export class CopyValueComponent {
  @Input() value: string | number | null | undefined;
  @Input() label: string = "Value";
  @HostBinding('class.always-visible') @Input() alwaysVisible: boolean = false;

  constructor(
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
  ) {}

  copy(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (this.value === null || this.value === undefined || this.value === "") return;

    const copied = this.clipboard.copy(String(this.value));
    this.snackBar.open(copied ? `${this.label} copied to clipboard` : `Could not copy ${this.label}`, 'OK', { duration: 2000 });
  }
}
